const initSlideshowAccordeon = () => {
	const initSlideshowAccordeonComponent = document.querySelectorAll(
		"section.slideshow-accordeon"
	);

	if (!initSlideshowAccordeonComponent.length) {
		return;
	}

	initSlideshowAccordeonComponent.forEach((component) => {
		const slides = component.querySelectorAll(".slide");
		const buttonNext = component.querySelector(".next");
		const buttonPrev = component.querySelector(".prev");

		const swipers = [];

		Array.from(slides).forEach(function (element) {
			if (
				Array.from(element.querySelectorAll(".swiper-inner-slide")).length > 1
			) {
				var swiper = new Swiper(element, {
					loop: true,
					effect: "fade",
					slideClass: "swiper-inner-slide",
					slidesPerView: 1,
					pagination: {
						el: element.querySelector(".swiper-pagination"),
						clickable: true,
					},
				});

				if (document.body.clientWidth > 640) {
					if (!element.classList.contains("active")) {
						swiper.disable();
					}
				}
			}

			if (swiper) {
				swipers.push(swiper);
			} else {
				swipers.push(null);
			}
		});

		slides.forEach((slide) => {
			slide.addEventListener("click", function () {
				if (document.body.clientWidth > 640) {
					slides.forEach((el) => {
						el.classList.remove("active");
					});
					slide.classList.add("active");

					buttonsActiveStateHandle(slides, buttonNext, buttonPrev);

					const activeIndex = Array.from(slides).findIndex((el) =>
						el.classList.contains("active")
					);
					swipersDisableActiveEnable(activeIndex);
				}
			});
		});

		buttonNext.addEventListener("click", function () {
			if (document.body.clientWidth > 640) {
				const activeIndex = Array.from(slides).findIndex((el) =>
					el.classList.contains("active")
				);
				Array.from(slides)[activeIndex + 1].click();
				buttonsActiveStateHandle(slides, buttonNext, buttonPrev);
				swipersDisableActiveEnable(activeIndex + 1);
			}
		});
		buttonPrev.addEventListener("click", function () {
			if (document.body.clientWidth > 640) {
				const activeIndex = Array.from(slides).findIndex((el) =>
					el.classList.contains("active")
				);
				Array.from(slides)[activeIndex - 1].click();

                buttonsActiveStateHandle(slides, buttonNext, buttonPrev);

				swipersDisableActiveEnable(activeIndex - 1);
			}
		});

		const width = document.body.clientWidth;
		if (width < 640) { 
			const innerSwiper = new Swiper(".accordeon-swiper", {
				slidesPerView: 1,
				spaceBetween: 20,

				navigation: {
					nextEl: ".next",
					prevEl: ".prev",
				},
			});
		}
	});
};

function buttonsActiveStateHandle(slides, buttonNext, buttonPrev) {
	const activeIndex = Array.from(slides).findIndex((el) =>
		el.classList.contains("active")
	);

	if (document.body.clientWidth > 640) {
        console.log(buttonNext, buttonPrev);
		if (activeIndex === 0) {
			buttonNext.classList.add("active");
			buttonPrev.classList.remove("active");
		} else if (activeIndex + 1 === Array.from(slides).length) {
			buttonNext.classList.remove("active");
			buttonPrev.classList.add("active");
		} else {
			buttonNext.classList.add("active");
			buttonPrev.classList.add("active");
		}
	}
}

function swipersDisableActiveEnable(activeIndex) {
	swipers.forEach((swiper) => {
		try {
			swiper.disable();
		} catch (error) {
			if (error instanceof TypeError) {
				// Swiper is not initialized, do nothing
			} else {
				console.log(error);
			}
		}
	});
	try {
		swipers[activeIndex].enable();
	} catch (error) {
		if (error instanceof TypeError) {
			// Swiper is not initialized, do nothing
		} else {
			console.log(error);
		}
	}
}

export { initSlideshowAccordeon };
